export default {
    discount: null,
    discounts: [],
    contacts: [],
    lines: [],
    products: [],
    brands: [],
    price_lists: [],
    params_contacts: {
        filter: "",
        type: "is_customer",
        paginate: false
    },
    params: {
        price_list_id: null,
        contact_id: null,
        brand_id: null,
        line_id: null,
        discount_percentage: null,
        perPage: 50,
        search: '',
        page: 1,
        products: [],
    },
    loading: {
        module:false,
        download_report : false
    },

    message_loading : 'Cargando Plantilla De Incorporación De Clientes',
    file: '',
    upload_file: false,
    preloader: false
};



// WEBPACK FOOTER //
// ./src/modules/customerDiscountBrand/state.js